import React from 'react';
import { useWindowDimensions } from '@/hooks/use-window-dimensions';

interface CustomTabsProps {
  tabs: string[];
  selectedIndex: number;
  onChange: (index: number) => void;
  className?: string;
}

const CustomTabs: React.FC<CustomTabsProps> = ({ tabs, selectedIndex, onChange, className }) => {
  const { screenIsLargeOrEqualThan } = useWindowDimensions();
  const isMobile = !screenIsLargeOrEqualThan('sm');

  return (
    <div
      className={`flex touch-pan-x gap-1 overflow-x-auto whitespace-nowrap
        ${isMobile ? 'justify-between' : 'justify-start'}
        ${className || ''}`}
    >
      {tabs.map((tab, idx) => (
        <button
          key={tab}
          type="button"
          onClick={() => onChange(idx)}
          className={`flex-shrink-0 rounded-full transition-colors
             ${
               isMobile
                 ? 'justify-between px-2 py-1 text-[14px]'
                 : 'justify-start px-3 py-2 text-[16px]'
             }
            ${
              selectedIndex === idx
                ? 'bg-N1000 text-white'
                : 'border border-N300 bg-white text-text-primaryLight hover:border-gray-400'
            }
            focus:outline-none`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default CustomTabs;
